function ContactCTA({ title, subtitle, variant = "button" }) {
  const scrollToContact = () => {
    document.getElementById("contact")?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div className="contact-cta">
      <div className="contact-cta-content">
        <h3>{title}</h3>
        <p>{subtitle}</p>
        {variant === "button" && (
          <button onClick={scrollToContact} className="cta-button">
            Get in touch
          </button>
        )}
      </div>
    </div>
  );
}

export default ContactCTA;
